import { render, staticRenderFns } from "./vip-card-group.vue?vue&type=template&id=3d8f9b70&scoped=true&"
import script from "./vip-card-group.vue?vue&type=script&lang=js&"
export * from "./vip-card-group.vue?vue&type=script&lang=js&"
import style0 from "./vip-card-group.vue?vue&type=style&index=0&id=3d8f9b70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8f9b70",
  null
  
)

export default component.exports